.cell {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--zumpo-cell-size, 44px);
  height: var(--zumpo-cell-size, 44px);
  margin: 0;
  padding: 0;
  border-radius: var(--zumpo-radius-8);
  /* Outlines are inset shadows, not borders, so the hit area and a pick
     marker cover the whole cell, as they do in Figma. */
  box-shadow: inset 0 0 0 1px var(--zumpo-line);
  background: var(--zumpo-cream);
  color: var(--zumpo-ink);
  font: var(--zumpo-text-number);
  letter-spacing: var(--zumpo-text-number-tracking);
}

.compact {
  --zumpo-cell-size: 26px;

  border-radius: var(--zumpo-radius-6);
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
}

/* Regular cells are 36 px on phones. */
@media (max-width: 640px) {
  .cell:not(.compact) {
    --zumpo-cell-size: 36px;
  }
}

.hidden {
  background: var(--zumpo-blue);
  box-shadow: var(--zumpo-shadow-cell-edge);
}

@media (hover: hover) {
  .pickable:hover {
    box-shadow:
      var(--zumpo-shadow-cell-edge),
      inset 0 0 0 2px var(--zumpo-ink);
  }
}

.actionable {
  /* A long-press flags; the page must not select text or open a callout. */
  -webkit-touch-callout: none;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

/* Keyboard focus: 2 px of ink, 2 px outside the cell. */
.cell:focus-visible {
  z-index: 1;
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

.picked {
  box-shadow: inset 0 0 0 2px var(--zumpo-ink);
  background: var(--zumpo-lime);
}

.mine {
  box-shadow: inset 0 0 0 1px var(--zumpo-danger);
  background: var(--zumpo-peach);
  color: var(--zumpo-danger);
}

.hitMine {
  background: var(--zumpo-danger);
  color: var(--zumpo-white);
}

.flag {
  color: var(--zumpo-danger);
}

.crossed {
  position: relative;
  display: flex;
}

.cross {
  position: absolute;
  inset: 0;
  stroke: var(--zumpo-ink);
  stroke-linecap: round;
}

.n1 {
  color: var(--zumpo-number-1);
}

.n2 {
  color: var(--zumpo-number-2);
}

.n3 {
  color: var(--zumpo-number-3);
}

.n4 {
  color: var(--zumpo-number-4);
}

.n5 {
  color: var(--zumpo-number-5);
}

.n6 {
  color: var(--zumpo-number-6);
}

.n7 {
  color: var(--zumpo-number-7);
}

.n8 {
  color: var(--zumpo-number-8);
}
